import site from "../site";
import ShareLink from "./share-link";

export default class ProductShare {
	private shareInputField = document.createElement('input');
	private trackingCategory = 'product';
	private trackingMedium = 'link';
	private trackingContent = 'product_link_share';
	private trackingAction = 'Link';
	private trackingLabel = 'Product Page';
	private selectedVariantSku: string | null = null;
	private variantEventFired = false;

	constructor() {
		this.shareInputField.style.position = 'absolute';
		this.shareInputField.style.opacity = '0';
		this.shareInputField.style.pointerEvents = 'none';
		this.shareInputField.tabIndex = -1;
 		this.shareInputField.setAttribute('aria-hidden', 'true');
		document.body.appendChild(this.shareInputField);

		document.addEventListener('variant-changed', (event: any) => {
			const variant = event.detail?.currentVariant;
			this.selectedVariantSku = variant?.Data?.Sku ?? null;
			this.variantEventFired = true;
		});

		document.querySelectorAll<HTMLButtonElement>('.js-add-to-share').forEach((button, index) => {
			const tooltipAttr = `data-product-share-tooltip-${index}`;
			const tooltip = button.closest('.js-add-to-share-container')?.querySelector('.js-add-to-share-tooltip');
			if (tooltip) {
				tooltip.setAttribute(tooltipAttr, '');
			}

			const shareId = button.getAttribute('data-product-share-id') ?? undefined;

			const shareHelper = new ShareLink({
				shareTitle: `Product at ${site.activeSiteSetting}`,
				shareText: `View this product on ${site.activeSiteSetting}:`,
				trackingCategory: this.trackingCategory,
				trackingMedium: this.trackingMedium,
				trackingContent: this.trackingContent,
				trackingAction: this.trackingAction,
				trackingLabel: this.trackingLabel,
				tooltipSelector: tooltip ? `[${tooltipAttr}]` : undefined,
				shareId: shareId,
			});

			button.addEventListener('click', () => {
				const sku = this.variantEventFired ? this.selectedVariantSku : undefined;
				const sanitisedUrl = ProductShare.sanitiseUrl(window.location.href, sku);
				shareHelper.shareUrl(sanitisedUrl, this.shareInputField);
			});
		});
	}

	private static sanitiseUrl(href: string, variantSku: string | null | undefined = undefined): string {
		const url = new URL(href);
		const sku = variantSku !== undefined ? variantSku : url.searchParams.get('sku');
		const ppc = url.searchParams.get('ppc');

		url.search = '';

		if (sku) {
			url.searchParams.set('sku', sku);
		}
		if (ppc === 'true') {
			url.searchParams.set('ppc', 'true');
		}

		return url.toString();
	}

}
